import * as React from 'react';
import { useSelector } from 'react-redux';

import { getAddressString, getMetroComponent } from './utils';
import { FavoritesItem, FavoritesTooltipLayout } from '../../components/Favorites';
import { IFavoritesState } from '../../types/favorites';
import { IApplicationState } from '../../types/redux';

interface IFavoritesTooltipContainerProps {
  target: '_blank' | '_self';
}

export const FavoritesTooltipContainer: React.FC<IFavoritesTooltipContainerProps> = ({ target }) => {
  const savedSearchesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.savedSearches);

  const favoritesLink = useSelector<IApplicationState, string>(state => state.servicesLinks.favorites as string);
  const favoritesList = useSelector<IApplicationState, IFavoritesState['favoriteItems']>(
    state => state.favorites.favoriteItems,
  );

  if (!favoritesList.length) {
    return null;
  }

  return (
    <FavoritesTooltipLayout favoritesLink={favoritesLink} searchLink={savedSearchesLink} target={target}>
      <>
        {favoritesList.map(({ title, fullUrl, bargainTerms, photoPreviewUrl, geo }, index) => (
          <FavoritesItem
            key={title + index}
            title={title}
            offerUrl={fullUrl}
            price={bargainTerms.priceText ?? null}
            imgUrl={photoPreviewUrl ?? null}
            address={getAddressString(geo.address)}
            metro={getMetroComponent(geo.undergrounds)}
          />
        ))}
      </>
    </FavoritesTooltipLayout>
  );
};
